import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyA52v_viI2altluA8LiAKASWeVLcXpLv_8",
  authDomain: "tunneltwin-7a383.firebaseapp.com",
  projectId: "tunneltwin-7a383",
  storageBucket: "tunneltwin-7a383.appspot.com",
  messagingSenderId: "812934878016",
  appId: "1:812934878016:web:ab74be3650454bd3b360a5",
  measurementId: "G-4EQ9J4WT2C"
};

export const firebaseApp = initializeApp(firebaseConfig);
